function traverseObjectKeys(obj, keyUpdate) {
  const plainObject = JSON.parse(JSON.stringify(obj));
  const camelObj = {};
  Object.keys(plainObject).forEach(key => {
    const camelKey = keyUpdate(key);
    if (plainObject[key] instanceof Object) {
      camelObj[camelKey] = traverseObjectKeys(plainObject[key], keyUpdate);
    } else {
      camelObj[camelKey] = plainObject[key];
    }
  });
  return camelObj;
}
export function convertPascalToCamel(obj) {
  return traverseObjectKeys(obj, key => key.charAt(0).toLowerCase() + key.substring(1));
}
export function convertCamelToPascal(obj) {
  return traverseObjectKeys(obj, key => key.charAt(0).toUpperCase() + key.substring(1));
}